<style lang="scss">
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .baodan-box{
        padding:40px 30px;
        color:#333333;

        p{
            line-height:24px;
            font-size:14px;
            .copyText{color:#5078e6}
            .copyBtn{
                padding:5px 10px;
            }
            a{text-decoration: underline;}
        }
        h3{
            text-align: center;
            font-size:20px;
            font-weight: normal;
        }
        h4{
            text-align: center;
            font-size:14px;
            font-weight: normal;
            span{
               color:#0098e0;
            }
        }
        .guideDetail{text-align: center;}
        .guidePic{
            text-align: center;
            width:488px;
            margin:15px 0 30px 0;

        }
        .gray{
            color:#999999;
        }



    }


</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>如何查询履约险保单</h2>
        </div>
        <div class="baodan-box">
            <p>
                您可以到PICC官网，用借款人姓名+借款合同号+验证码查看对应的保单。<br>
                您当前这笔借款单的借款合同号为：<span class="copyText">{{contractId}} &nbsp;</span> <el-button size="mini" class="copyBtn" type="primary"v-clipboard:copy="contractId" v-clipboard:success="onCopy">复制</el-button><br>
                人保财险官网：<a target="_blank" href="http://www.epicc.com.cn/">http://www.epicc.com.cn/</a><br>
                <br>
            </p>
            <p>
                具体步骤如下：
                <br>
            </p>
            <div class="guideDetail">
                <h3>第一步：登录</h3>
                <h4><span>•</span> 选择会员登录</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/1.png`" alt="">
                <h4><span>•</span> 输入手机号 — 滑块验证 — 输入短信动态验证码</h4>
                <p class="gray">备注：任意一个可以接受验证码的手机号均可</p>
                <img  class="guidePic" :src="`${baseUrl}baodan/2.png`" alt="">

                <h3>第二步：保单查询</h3>
                <h4><span>•</span> 进入官网首页，选择服务大厅——保单服务——保单查询</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/3.png`" alt="">
                <h4><span>•</span> 点击其他保险查询——信用保证保险保单查询和下载</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/4.png`" alt="">
                <h4><span>•</span> 选择保单号或者借款人姓名</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/5.png`" alt="">
                <h4><span>•</span> 保单号+借款合同号+验证码</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/6.png`" alt="">
                <h4><span>•</span> 借款人姓名+借款合同号+验证码</h4>
                <img  class="guidePic" :src="`${baseUrl}baodan/7.png`" alt="">

                <h3>第三步：保单/发票下载</h3>
                <h4> 点击按钮“查询并下载保单”保存即可</h4>

            </div>

        </div>




    </div>
</template>
<script>

	export default {

		data() {
			return {
				baseUrl:process.env.BASE_URL,
				capitalName:"",
				contractId:this.$route.params.contractId,
                contractList:[

                ]
			}

		},
        methods:{
			onCopy(){
				this.$message({
					message: '复制成功',
					type: 'success'
				});
			},


        },
        created(){

        }
	}
</script>